<template>
  <div class="col-md-6">
    <company-details
      :diff-data="diffData"
      :report="report"
      :showAnchor="true"
      :showDiff="showDiff"
    />
    <key-financials :diff-data="diffData" :report="report" :showDiff="showDiff" />
    <credit-scores :report="report" :showAnchor="true"></credit-scores>
  </div>
</template>

<script>
import toolsMixin from '@/components/reports/ToolsMixin';
import CompanyDetails from '@/components/reports/panels/CompanyDetails';
import KeyFinancials from '@/components/reports/panels/KeyFinancials';
import CreditScores from '@/components/reports/panels/CreditScores';

export default {
  components: {
    CompanyDetails,
    KeyFinancials,
    CreditScores,
  },
  mixins: [toolsMixin],
  props: ['diffData', 'report', 'showDiff'],
};
</script>

<style></style>
